// client/src/lib/materials.js — partner materials per mandate
// (migrations/079). Mirrors src/lib/materials.js. Which slots a mandate has
// comes from its work type (the signed EL is the master source) and whether
// it is a fund (Matt, 10/8):
//   Financial Advisory  investor deck, investor teaser, investor email
//   Strategic Advisory  customer presentation, customer teaser, customer email
//   Fund                adds track record to the investor set (Fund = the
//                       taxonomy profile's mandate_type FS; see migrations/068)

export function materialSets(mandate) {
  const wt = mandate?.work_type ?? []
  const isFund = mandate?.mandate_type === 'FS'
  const sets = []
  if (wt.includes('Financial Advisory') || isFund) {
    sets.push({ audience: 'Investor', title: 'Investor Materials',
      slots: ['Investor Deck', 'Investor Teaser', ...(isFund ? ['Track Record'] : [])] })
  }
  if (wt.includes('Strategic Advisory')) {
    sets.push({ audience: 'Customer', title: 'Business Development Materials',
      slots: ['Customer Presentation', 'Customer Teaser'] })
  }
  return sets
}

// mailto: link that opens the intro email in the partner's own email app.
export function mailtoHref(email) {
  const q = [email.subject && `subject=${encodeURIComponent(email.subject)}`, `body=${encodeURIComponent(email.body)}`]
  return `mailto:?${q.filter(Boolean).join('&')}`
}
